export default "__VITE_ASSET__ccdab1f9__"